module.exports = __webpack_public_path__ + "img/logo.d85155fe.png";